import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/services/order/order.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-manageorders',
  templateUrl: './manageorders.component.html',
  styleUrls: ['./manageorders.component.css']
})
export class ManageordersComponent implements OnInit {
  orderNo: string;
  orderHeader: any;
  data: any;
  isNotAgreed: boolean = true;
  orderConfirmed: boolean = false;
  loginUser: any;

  isUserAdmin: boolean;
  isUserHr: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
    private orderServices: OrderService, private userService: UserService) {
    this.orderNo = this.route.snapshot.params.ordernumber;

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserHr.subscribe(
      value => {
        this.isUserHr = value;
      });

    //alert(this.orderNo);
  }

  ngOnInit() {
    this.getPlacedOrder();
    this.getLoginUserDetail();
  }

  getLoginUserDetail() {
    this.userService.getUserProfile().subscribe(
      (data: any) => {
        this.loginUser = data;
        console.log(this.loginUser);
      }
    )
  }

  getPlacedOrder() {
    this.orderServices.getPlacedOrderItem(this.orderNo).subscribe(
      (data: any) => {
        this.orderHeader = data;
        this.data = this.orderHeader.orderDetail;
        console.log(this.orderHeader);
      }
    )
  }

  agreeCond(e) {
    if (e.target.checked) {
      this.isNotAgreed = false;
    }
    else {
      this.isNotAgreed = true;
    }
  }

  confirmOrder() {
    this.isNotAgreed = true;
    console.log(this.orderHeader);
    //alert("Order Confirmed");
    this.orderServices.confirmOrder(this.orderHeader).subscribe(
      (data: any) => {
        if (data == true) {

          //alert("Order Confirmed");
          this.orderConfirmed = true;
        }
        else {
          alert("Order Failed");
          this.orderConfirmed = false;
        }
      }
    )
  }

  printRecipt() {

    //var printContents = document.getElementById(divName).innerHTML;
    //var originalContents = document.body.innerHTML;
    //document.body.innerHTML = printContents;
    //window.print();
    //document.body.innerHTML = originalContents;

    let printContents, popupWin;
    printContents = document.getElementById('printableContent').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Mother Parkers Tea &amp; Coffee Inc.</title>
          <style>
          #tabledata th
          {
            text-align:left;
          }
          body
          {
            margin-top:20px;
            font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
          }
          #signSection
          {
            margin-top:10px;
          }
          #signLine
          {
            margin-top:50px !Important;
            float:right;
          }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();

  }

  cancelOrder() {
    if (this.orderNo != null) {
      this.router.navigate(['/cancelorder', this.orderNo]);
    }
  }

  filledOrder() {
    this.orderServices.filledOrder(this.orderNo).subscribe(
      (data: any) => {
        if (data == true) {
          this.getPlacedOrder();
          alert("order filed");
        }
      }
    )
  }

  goBack() {
    window.history.back();
  }
}
